module.exports = __webpack_public_path__ + "img/标准文件1.696cfb82.png";